
import { computed, defineComponent, onMounted, PropType, reactive, watch } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// types
import { CompletedAdditionalServicesT } from '@/core/types/create_order.types'

// validations
import useVuelidate from '@vuelidate/core'
import { requiredIf, integer } from '@vuelidate/validators'

// constants
import { ADDITIONAL_SERVICES_KEYS } from '@/core/constants/ltl.constants'
import { AdditionalServiceModalFTLI } from '@/core/types/additional_services.types'

export default defineComponent({
    components: {
        TheButton,
        Checkbox,
        TheInput,
    },
    props: {
        stepNumber: {
            type: Number,
            default: null,
        },
        toggle: {
            type: Boolean,
            default: false,
        },
        opened: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Array as PropType<AdditionalServiceModalFTLI[]>,
            default: null,
        },
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const state = reactive({
            hasCar: false,
            hasCrane: false,
            hasGrid: false,
            hasHydraulicTrolley: false,
            hasLoader: false,
            hasManipulator: false,
            hasPallet: false,
            hasSoftPackage: false,
        })

        const state_toggle = reactive({
            is_open: true,
        })

        const additional_state = reactive({
            loader_value: null as number | null,
        })

        const completed_state = reactive({
            additional_service: null as CompletedAdditionalServicesT | null,
        })

        const AdditionalValidation = {
            loader_value: { required: requiredIf(() => state.hasLoader), integer },
        }

        const state_form$ = useVuelidate(AdditionalValidation, additional_state)

        const resetForm = () => {
            state.hasCar = false
            state.hasCrane = false
            state.hasGrid = false
            state.hasHydraulicTrolley = false
            state.hasLoader = false
            state.hasManipulator = false
            state.hasPallet = false
            state.hasSoftPackage = false

            completed_state.additional_service = null
            emit('reset')
        }

        const emitSubmit = () => {
            state_form$.value.$touch()
            if (props.disabled || state_form$.value.$invalid) return

            completed_state.additional_service = {
                ...state,
            }

            emit('submit', {
                ...state,
                hasLoader: state.hasLoader ? { value: additional_state.loader_value } : false,
            })
        }

        const updateAdditionalServices = () => {
            completed_state.additional_service = null
        }

        const setInfo = () => {
            if (props.toggle) state_toggle.is_open = false
            if (!props.initialValue || !Array.isArray(props.initialValue)) return

            for (const service_name in state) {
                const key = ADDITIONAL_SERVICES_KEYS[service_name]
                const a_s_found = props.initialValue.find(
                    (a_s: AdditionalServiceModalFTLI) => a_s.type_code === key
                )

                if (a_s_found) {
                    // @ts-ignore
                    state[service_name] = true
                    if (a_s_found.type_code === 'loader') {
                        additional_state.loader_value = Number(a_s_found.value)
                    }
                }
            }
        }

        const toggleForm = () => {
            state_toggle.is_open = !state_toggle.is_open
        }

        watch(
            () => props.opened,
            (newest) => {
                if (!newest) {
                    resetForm()
                }
            }
        )

        const isCompleted = computed(() => Boolean(completed_state.additional_service))
        const getLoaderText = computed(() => {
            if (!additional_state.loader_value) return '- грузчиков'

            const count = Number(additional_state.loader_value)
            const lastDigit = count % 10

            if (lastDigit === 1 && count !== 11) {
                return `${count} грузчик`
            } else if (2 <= lastDigit && lastDigit <= 4 && !(12 <= count && count <= 14)) {
                return `${count} грузчика`
            } else {
                return `${count} грузчиков`
            }
        })
        const isOpen = computed(() => {
            return (!props.toggle && props.opened) || (props.toggle && state_toggle.is_open)
        })

        onMounted(setInfo)

        return {
            state_toggle,
            state,
            additional_state,
            completed_state,
            state_form$,
            //
            emitSubmit,
            resetForm,
            isCompleted,
            updateAdditionalServices,
            getLoaderText,
            toggleForm,
            isOpen,
        }
    },
})
